export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/coas`,
        name: `${prefix}.accounts.coas.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.coas.index`,
                PageDescription: "Accounts Chart Of Accounts",
            },
        },
    },
];
